// extracted by mini-css-extract-plugin
module.exports = {"theme":"#c73122"};